module.exports = __webpack_public_path__ + "img/topztqd_bg.4d304497.png";